import { Grid, Typography } from '@material-ui/core'
import React, { useCallback, useContext, useEffect } from 'react'
import styled from 'styled-components'

import CheckoutLayout from '../../../layouts/buy/CheckoutLayout'
import { CheckoutNavigationBarOptionsContext } from '../../../layouts/context'
import { useAuth } from '../../../lib/auth'
import useCheckoutNavBarOptionValue from '../../../lib/cart/hooks/useCheckoutNavBarOptionValue'
import { usePageUrl } from '../../../lib/pages'
import Spinner from '../../Spinner'
import { GridButton } from '../shared/GridButton'

const DescriptionSection = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
`

const DescriptionText = styled(Typography)`
  margin-top: 2em;
  text-align: center;
  font-size: 24px;
`

const checkoutPath = '/checkout/shipping'

const CheckoutOnboarding = () => {
  const { user, isLoading } = useAuth()
  const { navBarOptionValue } = useCheckoutNavBarOptionValue('setup')
  const { displayOnboarding, loading: loadingNavBarOptions } = useContext(
    CheckoutNavigationBarOptionsContext,
  )
  const { navigate } = usePageUrl()
  const loadingUser = isLoading || !user

  const onClickCompleteSetup = useCallback(() => {
    navigate(`/onboarding?origin=${encodeURIComponent(checkoutPath)}`)
  }, [navigate])

  useEffect(() => {
    if (!displayOnboarding) {
      navigate(checkoutPath)
    }
  }, [displayOnboarding, loadingNavBarOptions, loadingUser, navigate])

  if (loadingUser || loadingNavBarOptions) {
    return <Spinner loading />
  }

  return (
    <>
      {displayOnboarding && (
        <CheckoutLayout checkoutNavigationBarTabValue={navBarOptionValue}>
          <Grid alignItems="center" justify="center" className="" container item xs={12}>
            <Grid item xs={12} md={8}>
              <DescriptionSection>
                <DescriptionText variant="body1">
                  Please select your practitioner before continuing with your checkout process
                </DescriptionText>
              </DescriptionSection>
              <Grid justify="center" container item xs={12}>
                <GridButton onClick={onClickCompleteSetup}>Complete Setup</GridButton>
              </Grid>
            </Grid>
          </Grid>
        </CheckoutLayout>
      )}
    </>
  )
}

export default CheckoutOnboarding
